import './ContactPage.css';
import ContactFormComponent from './ContactFormComponent/ContactFormComponent';
import MapComponent from './MapComponent/MapComponent';
import { MdEmail, MdLocationPin } from 'react-icons/md';
import { IconContext } from 'react-icons';
import { SiFacebook, SiYoutube } from 'react-icons/si';
import { AiFillInstagram } from 'react-icons/ai';
import { useContact } from '../../contexts/ContactContext';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ContactPage = () => {
  const { contactData, isLoaded } = useContact();
  const email = contactData?.email || '';
  const address = contactData?.address || {};
  const social = contactData?.socialMedia || {};
  const location = useLocation();

  // Scroll to top when component mounts or route changes
  useEffect(() => {
    // Use a small delay to ensure the component is fully mounted
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]); // Re-run when the pathname changes

  if (!isLoaded) {
    return (
      <div className='contact-page container flex'>
        <div className='page-title variation-3' id='contact'>
          <h3>Contact</h3>
          <div className='page-title-accent-line'></div>
        </div>
        <div className='inline-elements inline-elements-top'>
          <p>Loading contact information...</p>
        </div>
      </div>
    );
  }

  return (
    <div className='contact-page container flex'>
              <div className='page-title variation-3' id='contact'>
          <h3>Contact</h3>
          <div className='page-title-accent-line'></div>
        </div>

      <div className='inline-elements inline-elements-top'>
        <IconContext.Provider
          value={{
            color: 'hsl(var(--clr-red))',
            size: '2.25em',
            className: 'social-media-icons',
          }}
        >
          <div className='social-media-container shadowed-box flex clr-red rounded-sm'>
            <div className='social-media '>
              <ul className='flex'>
                <li 
                  className='sm-item'
                  tabIndex="0"
                  role="button"
                  onClick={() => social.instagram?.url && window.open(social.instagram.url)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      social.instagram?.url && window.open(social.instagram.url);
                    }
                  }}
                  aria-label={`Follow us on Instagram: ${social.instagram?.display || ''}`}
                >
                  <AiFillInstagram
                    title={`Follow us on Instagram: ${social.instagram?.display || ''}`}
                  />
                </li>
                <li 
                  className='sm-item'
                  tabIndex="0"
                  role="button"
                  onClick={() => social.youtube?.url && window.open(social.youtube.url)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      social.youtube?.url && window.open(social.youtube.url);
                    }
                  }}
                  aria-label={`Subscribe to our YouTube: ${social.youtube?.display || ''}`}
                >
                  <SiYoutube
                    title={`Subscribe to our YouTube: ${social.youtube?.display || ''}`}
                  />
                </li>
                <li 
                  className='sm-item'
                  tabIndex="0"
                  role="button"
                  onClick={() => social.facebook?.url && window.open(social.facebook.url)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      social.facebook?.url && window.open(social.facebook.url);
                    }
                  }}
                  aria-label={`Follow us on Facebook: ${social.facebook?.display || ''}`}
                >
                  <SiFacebook
                    title={`Follow us on Facebook: ${social.facebook?.display || ''}`}
                  />
                </li>
              </ul>
            </div>
          </div>
        </IconContext.Provider>

        <IconContext.Provider
          value={{
            color: 'hsl(var(--clr-red))',
            className: 'global-class-name',
            size: '21px',
            margin: '0, 0, -5px, 0',
          }}
        >
          <div className='contact-list-container flex'>
            <div className='contact-list flex'>
              <ul className='shadowed-box contact-list-items rounded-sm flex'>
                <li>
                  <a
                    href={`mailto:${email}?&subject=From Shinobi Academy website`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <MdEmail /> Send us an Email
                  </a>
                </li>
                <li>
                  <MdLocationPin /> {address.full || ''}
                </li>
              </ul>
            </div>
          </div>
        </IconContext.Provider>
      </div>

      <div className='inline-elements inline-elements-bottom'>
        <MapComponent />
        <ContactFormComponent />
      </div>
    </div>
  );
};

export default ContactPage;
